import {APIClient} from '../utils/APIClient';
import {API_URL} from '../settings/local_settings';

// Capa API de las alertas VIGENTES (UX 2.1). La pill del Listado de Clientes y el KPI del Panel
// dicen CUÁNTAS cosas están rotas —ese número ya viaja en el payload de cada pantalla—; acá se pide
// CUÁLES son, sólo cuando el usuario abre el popover.
//
// `GET agency-client/<id>/active-alerts/` devuelve
// `{status:'OK', data:{count, snoozed_count, window_days, items:[...]}}`, con las activas primero
// (críticas arriba) y las silenciadas al final. Los gates —portal-user, cliente de otra agencia,
// agencia sin la 2.1— vuelven como 404 uniforme `{error_code:'NOT_FOUND'}`.
//
// **No hay endpoints de escritura propios**: cada ítem trae en `snooze` las coordenadas con las que
// llamar a los endpoints de silenciado que ya existen, y `snooze` decide a cuál de los dos se va:
//
//   scope BUSINESS_UNIT -> `business-unit/<id>/alert-snooze`  (body: {period, indicator})
//   scope AGENCY        -> `alert-snooze`                     (body: {period, indicator, sub_indicator})
//
// La elección NO se deduce acá: la manda el backend, que es el único que sabe con qué indicador
// quedó guardado un silencio (un mismo tipo de alerta puede tener varios, y el DELETE busca la fila
// por indicador — reactivar con el equivocado no borra nada).
//
// ⚠️ `APIClient` no rechaza en 4xx: siempre hay que mirar `status === 'OK'`.
const SNOOZE_SCOPE_BUSINESS_UNIT = 'BUSINESS_UNIT';

function snoozeRequest(coordinates) {
    const isLineScoped = coordinates.scope === SNOOZE_SCOPE_BUSINESS_UNIT;
    const url = isLineScoped
        ? `${API_URL}business-unit/${encodeURIComponent(coordinates.business_unit_id)}/alert-snooze`
        : `${API_URL}alert-snooze`;
    // El endpoint por línea NO acepta `sub_indicator` (lo fija en null); el de agencia lo exige.
    const body = isLineScoped
        ? {indicator: coordinates.indicator}
        : {indicator: coordinates.indicator, sub_indicator: coordinates.sub_indicator};
    return {url, body};
}

export const AlertsApi = {
    getActiveAlerts(clientId) {
        const tzOffset = new Date().getTimezoneOffset();
        const url = `${API_URL}agency-client/${encodeURIComponent(clientId)}/active-alerts/`
            + `?tz_offset=${tzOffset}`;
        return new APIClient(url).call('GET');
    },

    // «Ahora» del Centro de Alertas: las de TODOS los clientes que el usuario ve, agrupadas por
    // cliente (`{status: 'OK', result: {count, snoozed_count, window_days, truncated, clients_total,
    // clients: [{client_id, client_name, count, snoozed_count, items}]}}`). Cada ítem es el mismo del
    // endpoint por cliente. Sin el Centro, el 404 uniforme.
    getAgencyActiveAlerts() {
        const tzOffset = new Date().getTimezoneOffset();
        return new APIClient(`${API_URL}agency/active-alerts/?tz_offset=${tzOffset}`).call('GET');
    },

    snooze(coordinates, period) {
        const {url, body} = snoozeRequest(coordinates);
        return new APIClient(url).call('POST', {...body, period});
    },

    unsnooze(coordinates) {
        const {url, body} = snoozeRequest(coordinates);
        return new APIClient(url).call('DELETE', body);
    },
};
